module.exports={"(optional)":"(opcjonalne)","(required)":"(wymagane)"};